import React from "react";
import { useScrollAnimation } from "../hooks/useScrollAnimation";

function Motivational() {
  const [h2Ref, h2Visible] = useScrollAnimation();
  const [h3Ref, h3Visible] = useScrollAnimation();
  const [h1Ref, h1Visible] = useScrollAnimation();

  return (
    <div className="motivational-wrapper">
      <div className="motivational container">
        <h2 
          ref={h2Ref}
          className={h2Visible ? "animate-in" : ""}
        >
          We don't just shape steel
        </h2>
        <h3 
          ref={h3Ref}
          className={h3Visible ? "animate-in" : ""}
        >
          we shape
        </h3>
        <h1 
          ref={h1Ref}
          className={h1Visible ? "animate-in" : ""}
        >
          STRENGTH ITSELF
        </h1>
      </div>
    </div>
  );
}

export default Motivational;
